import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M19.34 3.968c.966 0 1.75.783 1.75 1.75v11.01c0 .966-.784 1.75-1.75 1.75H9.306c-.044 0-.088.011-.127.034l-3.522 2.087c-.27.16-.578.244-.892.244-.967 0-1.75-.783-1.75-1.75V5.718c0-.87.634-1.592 1.466-1.727l.14-.018.1-.004zM4.808 5.466l-.1.008c-.111.026-.193.125-.193.244v13.375c0 .139.112.25.25.25.044 0 .088-.012.127-.034l3.522-2.087c.27-.16.578-.245.892-.245H19.34c.139 0 .25-.112.25-.25V5.717c0-.137-.111-.25-.25-.25H4.81zM12 10c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-4 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm8 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
      })
    ], -1)
  ]))]))
}
export default { render: render }